/**
 * cn — concatenate Tailwind className strings with truthy filtering.
 *
 * Tiny dep-free alternative to clsx/classnames. Drops falsy values so
 * conditional classes are clean:
 *
 *   cn('px-3 py-2', isDark && 'bg-gray-900', error && 'border-red-500')
 *   → 'px-3 py-2 bg-gray-900'   (when isDark=true, error=false)
 */
export function cn(...parts: Array<string | false | null | undefined>): string {
    return parts.filter(Boolean).join(' ');
}
